<template>
  <div v-if="leiaAtiva">
    <top-bar />
    <main class="content pedidos-page">
      <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
        <h4>Pedidos coletados</h4>
        <div class="d-flex align-items-center">
          <label class="mb-0 mr-3">
            <select v-model="filtro" aria-label="Filtrar pedidos" class="form-control form-control-sm" :disabled="salvando"><option value="ativos">Kanban</option><option value="descartados">Descartados</option></select>
          </label>
          <button class="btn btn-outline-primary" @click="atualizar" :disabled="carregando || salvando" :aria-busy="carregando ? 'true' : 'false'">
            <i class="fa fa-sync-alt mr-1" :class="{ 'fa-spin': carregando }" aria-hidden="true"></i> Atualizar
          </button>
        </div>
      </div>
      <div v-if="erro" class="alert alert-danger" role="alert">{{ erro }} <button class="btn btn-sm btn-outline-danger" @click="atualizar">Tentar novamente</button></div>
      <span class="sr-only" role="status">{{ carregando ? 'Atualizando pedidos…' : '' }}</span>
      <div class="quadro" :class="{'descartados': filtro === 'descartados'}">
        <section v-for="coluna in colunas" :key="coluna.status" class="coluna">
          <h5 class="d-flex justify-content-between">{{ coluna.nome }} <span class="badge badge-light">{{ quantidade(coluna.status) }}</span></h5>
          <div class="coluna-pedidos" tabindex="0" :aria-label="`Pedidos: ${coluna.nome}`">
            <p v-if="!listas[coluna.status].length && !carregando" class="text-muted small">Nenhum pedido.</p>
            <div v-for="pedido in listas[coluna.status]" :key="pedido.id_chatbot_pedido" class="pedido-card">
              <button type="button" class="pedido-detalhes" @click="selecionado = pedido">
              <div class="d-flex justify-content-between"><strong>{{ pedido.nome_user || pedido.telefone || 'Cliente' }}</strong><small>#{{ pedido.id_chatbot_pedido }}</small></div>
              <div class="small text-muted my-2">{{ horario(pedido.created_at) }}</div>
              <div>{{ modalidade(pedido) }}</div><strong>{{ valor(pedido) }}</strong>
              <div v-if="pendencias(pedido).length" class="text-warning small mt-2"><i class="fa fa-exclamation-triangle"></i> {{ pendencias(pedido).length }} pendência(s)</div>
              </button>
              <button v-if="Number(pedido.status) === 2" type="button" class="btn btn-primary btn-sm btn-block mt-3" :disabled="salvando" @click="alterarStatus(3, pedido)">Aprovar pedido</button>
            </div>
            <button v-if="mais[coluna.status]" class="btn btn-outline-secondary btn-block" :disabled="carregando || !!buscando[coluna.status]" @click="carregarMais(coluna.status)">{{ buscando[coluna.status] ? 'Carregando…' : 'Carregar mais' }}</button>
          </div>
        </section>
      </div>
    </main>
    <modal :opened="!!selecionado" preview="true" @fechar="fechar">
      <div v-if="selecionado">
        <h5>{{ selecionado.nome_user || selecionado.telefone || 'Cliente' }}</h5>
        <p class="text-muted">#{{ selecionado.id_chatbot_pedido }} · {{ horario(selecionado.created_at) }} · {{ nomes[Number(selecionado.status)] }}</p>
        <pre class="resumo">{{ selecionado.dados.resumo == null ? 'Resumo ainda não disponível. A Léia está montando o pedido.' : selecionado.dados.resumo }}</pre>
        <div v-if="pendencias(selecionado).length" class="alert alert-warning"><strong>Pendências</strong><ul class="mb-0"><li v-for="(pendencia, i) in pendencias(selecionado)" :key="i">{{ pendencia }}</li></ul></div>
        <button class="btn btn-success mb-3" @click="abrirWhatsApp" :disabled="salvando || !selecionado.telefone">Abrir WhatsApp</button>
        <p v-if="Number(selecionado.status) === 1" class="small text-muted">Aguardando a autorização do cliente pela Léia para passar a Pendente.</p>
        <div class="d-flex flex-wrap">
          <button v-if="[1, 2].includes(Number(selecionado.status))" class="btn btn-outline-danger mb-2" :disabled="salvando" @click="alterarStatus(4)">Descartar</button>
        </div>
      </div>
      <template v-slot:acoes>
        <button v-if="selecionado && Number(selecionado.status) === 2" type="button" class="btn btn-primary px-4 py-2" :disabled="salvando" @click="alterarStatus(3)">Aprovar pedido</button>
      </template>
    </modal>
  </div>
</template>
<script>
import TopBar from '@/components/commons/TopBar';
import Modal from '@/components/commons/Modal';
export default {
  components: { TopBar, Modal },
  data: () => ({ filtro: 'ativos', listas: { 1: [], 2: [], 3: [], 4: [] }, paginas: {}, mais: {}, buscando: {}, selecionado: null, carregando: false, salvando: false, erro: '', geracao: 0, timer: null,
    nomes: { 1: 'Em montagem', 2: 'Pendente', 3: 'Aprovado', 4: 'Descartado' } }),
  computed: {
    leiaAtiva() { return this.$store.getters['configs/leiaAtiva']; },
    empresa() { return this.$store.state.empresas.find(e => e.isDefault) || {}; },
    session() { return this.$store.state.session; },
    contexto() { return `${this.empresa.connectionId}:${this.empresa.x_auth}:${(this.session || {}).phone}:${(this.session || {}).wpp}`; },
    colunas() { return (this.filtro === 'descartados' ? [4] : [1, 2, 3]).map(status => ({ status, nome: this.nomes[status] })); }
  },
  watch: {
    leiaAtiva(ativa) {
      if (!ativa) this.redirecionar();
    },
    contexto() { if (this.leiaAtiva) this.reiniciar(); },
    filtro() { this.reiniciar(); }
  },
  methods: {
    redirecionar() {
      clearInterval(this.timer);
      this.geracao++;
      this.$router.replace(this.isElectron ? '/home' : '/chamados');
    },
    quantidade(status) { const c = this.$store.state.pedidosColetados.contador; return status === 4 ? this.listas[4].length + (this.mais[4] ? '+' : '') : c[{ 1: 'em_montagem', 2: 'pendentes', 3: 'lancados' }[status]]; },
    pendencias(p) { return p.dados.pendencias || []; },
    modalidade(p) { return ({ entrega: 'Entrega', retirada: 'Retirada' })[(p.dados.pedido || {}).modalidade] || 'Entrega/retirada a definir'; },
    valor(p) {
      const dados = p.dados.pedido || {};
      const final = dados.total_centavos != null;
      const valor = final ? dados.total_centavos : dados.subtotal_centavos;
      return valor == null ? 'Valor a definir' : `${final ? 'Total' : 'Total parcial'}: ${(valor / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
    },
    horario(data) { if (!data) return 'Horário não informado'; const date = new Date(data.replace(' ', 'T')); return isNaN(date.getTime()) ? data : date.toLocaleString('pt-BR'); },
    mensagem(e) { return (e.data && (e.data.msg || e.data.erro)) || 'Não foi possível consultar os pedidos. Tente novamente.'; },
    reiniciar() {
      this.geracao++; this.carregando = false;
      this.listas = { 1: [], 2: [], 3: [], 4: [] }; this.paginas = {}; this.mais = {}; this.buscando = {}; this.selecionado = null;
      this.atualizar();
    },
    async buscar(status, page, geracao) {
      const response = await this.$http.get('v2/chatbot/pedidos', { params: { status, page, limite: 30 }, headers: { 'x-lecard-key': this.empresa.x_auth } });
      if (geracao !== this.geracao) return;
      const pedidos = response.data.pedidos;
      this.$set(this.listas, status, page ? this.listas[status].concat(pedidos).filter((p, i, a) => a.findIndex(x => x.id_chatbot_pedido === p.id_chatbot_pedido) === i) : pedidos);
      this.$set(this.paginas, status, page); this.$set(this.mais, status, pedidos.length === 30);
      if (this.selecionado && Number(this.selecionado.status) === status && page === 0) this.selecionado = pedidos.find(p => p.id_chatbot_pedido === this.selecionado.id_chatbot_pedido) || null;
    },
    async atualizar() {
      if (!this.empresa.x_auth || this.salvando) return;
      const geracao = ++this.geracao; this.carregando = true; this.erro = '';
      try {
        const results = await Promise.allSettled([...this.colunas.map(c => this.buscar(c.status, 0, geracao)), this.$store.dispatch('pedidosColetados/atualizar', this.$http)]);
        const failure = results.find(r => r.status === 'rejected');
        if (failure && geracao === this.geracao) this.erro = this.mensagem(failure.reason);
      } finally { if (geracao === this.geracao) this.carregando = false; }
    },
    async carregarMais(status) {
      const geracao = this.geracao; this.$set(this.buscando, status, true);
      try { await this.buscar(status, this.paginas[status] + 1, geracao); }
      catch (e) { if (geracao === this.geracao) this.erro = this.mensagem(e); }
      finally { if (geracao === this.geracao) this.$set(this.buscando, status, false); }
    },
    moverPedido(pedido, status) {
      const atualizado = { ...pedido, status };
      for (const origem of [1, 2, 3, 4]) {
        this.$set(this.listas, origem, this.listas[origem].filter(p => p.id_chatbot_pedido !== pedido.id_chatbot_pedido));
      }
      this.$set(this.listas, status, [...this.listas[status], atualizado].sort((a, b) =>
        String(a.created_at).localeCompare(String(b.created_at)) || a.id_chatbot_pedido - b.id_chatbot_pedido));
      if (this.selecionado && this.selecionado.id_chatbot_pedido === pedido.id_chatbot_pedido) this.selecionado = null;
    },
    fechar() { if (!this.salvando) this.selecionado = null; },
    async alterarStatus(status, pedido = this.selecionado) {
      if (!pedido || this.salvando) return;
      const contexto = this.contexto, selecionado = this.selecionado;
      const confirmou = status === 3 || await this.$swal({ text: 'Deseja descartar este pedido coletado?', buttons: ['Voltar', 'Confirmar'], dangerMode: true });
      if (!confirmou || contexto !== this.contexto || this.selecionado !== selecionado || this.salvando) return;
      this.salvando = true;
      this.geracao++; this.carregando = false; this.buscando = {};
      try {
        await this.$http.post(`v2/chatbot/pedidos/${pedido.id_chatbot_pedido}/status`, { status }, { headers: { 'x-lecard-key': this.empresa.x_auth } });
        if (contexto === this.contexto) {
          this.moverPedido(pedido, status);
          this.$store.dispatch('pedidosColetados/atualizar', this.$http).catch(() => {});
        }
      } catch (e) { if (contexto === this.contexto) this.$swal(this.mensagem(e)); }
      finally { this.salvando = false; }
    },
    abrirWhatsApp() {
      if (this.isElectron && !this.session) { this.$swal('O WhatsApp ainda está sendo iniciado. Aguarde para abrir a conversa.'); return; }
      const telefone = this.$helpers.normalizarTelefone(this.selecionado.telefone);
      if (this.session) { window.control.acessarChat({ to: telefone + '@c.us', wpp: this.session.wpp }); this.$emit('goHome'); }
      else window.open('https://wa.me/' + telefone, '_blank', 'noopener,noreferrer');
    }
  },
  sockets: {
    chatbot_pedido(data) {
      if (!this.leiaAtiva || !data || String(data.id_empresa) !== String(this.empresa.id_empresa)) return;
      if (this.salvando) return;
      const pedido = Object.values(this.listas).flat().find(p => String(p.id_chatbot_pedido) === String(data.id_chatbot_pedido));
      if (pedido && [3, 4].includes(Number(data.status))) {
        this.geracao++; this.carregando = false; this.buscando = {};
        this.moverPedido(pedido, Number(data.status));
        return;
      }
      this.atualizar();
    }
  },
  mounted() {
    if (!this.leiaAtiva) {
      this.redirecionar();
      return;
    }

    this.atualizar();
    this.timer = setInterval(() => { if (!this.carregando && !this.salvando && !this.selecionado && !Object.values(this.buscando).some(Boolean) && !Object.values(this.paginas).some(p => p > 0)) this.atualizar(); }, 5 * 60 * 1000);
  },
  beforeDestroy() { clearInterval(this.timer); this.geracao++; }
};
</script>
<style scoped>
.pedidos-page { display: flex; flex-direction: column; height: 100dvh; margin-bottom: 0; padding: 52px 24px 32px; overflow: hidden; }
.pedidos-page > .d-flex, .pedidos-page > .alert { flex-shrink: 0; }
.quadro { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 18px; flex: 1; min-height: 0; }
.quadro.descartados { grid-template-columns: minmax(0, 1fr); }
.coluna { display: flex; flex-direction: column; background: #f0f2f5; border-radius: 8px; padding: 16px; min-height: 0; height: 100%; min-width: 0; overflow: hidden; }
.coluna-pedidos { flex: 1; min-height: 0; overflow-y: auto; overscroll-behavior-y: contain; scrollbar-gutter: stable; }
.coluna h5 { flex-shrink: 0; font-size: 1rem; margin-bottom: 18px; }
.pedido-card { display: block; width: 100%; border: 1px solid #dee2e6; background: white; border-radius: 6px; padding: 16px; margin-bottom: 12px; text-align: left; color: inherit; overflow-wrap: anywhere; }
.pedido-detalhes { display: block; width: 100%; border: 0; background: transparent; padding: 0; text-align: left; color: inherit; font: inherit; }
.pedido-card:hover, .pedido-card:focus-within { border-color: var(--primary); }
.resumo { white-space: pre-wrap; overflow-wrap: anywhere; font-family: inherit; font-size: inherit; }
@media(max-width: 991px) { .quadro { grid-template-columns: repeat(3, minmax(260px, 1fr)); overflow-x: auto; } .quadro.descartados { grid-template-columns: minmax(0, 1fr); } .pedidos-page { padding: 48px 12px 100px; } }
</style>
